import React, { useContext, useState } from 'react'
import { Link } from 'gatsby'
import cx from 'classnames'
import { CartSlideout } from 'src/components/cart/CartSlideout/CartSlideout'
import SearchNav from 'src/components/navigation/Search'
import { StoreContext } from 'src/context/store-context'
import Logo from 'src/icons/logo'
import CartButton from './CartButton'
import DesktopMenu from './DesktopMenu'
import PhoneDropdown from './PhoneDropdown'

const TopNav = () => {
  const { checkout } = useContext(StoreContext)
  const [showCart, setShowCart] = useState(false)

  const quantity = (checkout ? checkout.lineItems : []).reduce(
    (total, item) => {
      return total + item.quantity
    },
    0,
  )

  return (
    <>
      <div className='tailwindcss fixed top-0 z-[1030] w-full bg-white pb-[16px]'>
        <div className='container'>
          <div className='grid h-20 grid-cols-4'>
            <div className='flex items-center'>
              <Link href='/'>
                <Logo />
              </Link>
            </div>
            <div className='col-span-2 flex items-center'>
              <div className='w-full'>
                <SearchNav />
              </div>
            </div>
            <div className='flex items-center justify-center gap-12'>
              <PhoneDropdown />
              <CartButton
                quantity={quantity}
                onClick={() => setShowCart(true)}
              />
            </div>
          </div>
        </div>
        <DesktopMenu />
      </div>
      <div
        onClick={() => setShowCart(false)}
        className={cx(
          'fixed inset-0 z-10 bg-black/70 transition duration-500',
          showCart
            ? 'pointer-events-auto opacity-100'
            : 'pointer-events-none opacity-0',
        )}
      />
      <CartSlideout showCart={showCart} setShowCart={setShowCart} />
    </>
  )
}

export default TopNav
